import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import { TopNavigationBarMobile } from "../../navigationSection/TopNavigationBarMobile";
import OrderTrackMain from "./OrderTrackMain";

class OrderTrack extends Component {
  render() {
    return (
      <React.Fragment>
        <Container fluid className="vendor-orders-request">
          <Row>
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>
            <div className="top-panel">
              <TopNavigationBarMobile displayLeft="logo" />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation />
              <Container fluid>
                {/* <Row>
                  <Col md={8}> */}
                <OrderTrackMain />
                {/* </Col>
                  <Col md={4}>
                    <RightComponentOrderTrack />
                  </Col>
                </Row> */}
              </Container>
            </div>
            <div className="bottom-panel"></div>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default OrderTrack;
